import { useFlags } from 'launchdarkly-react-client-sdk';
import { LAUNCHDARKLY_TOGGLES } from '@studio/constants/launchdarkly-toggle-constants';
import UrlPaths from '@studio/constants/url-paths';
import { getCalendarDefaultPath } from '@studio/helpers/navigation/getCalendarDefaultPath';

const useScheduleHomePath = () => {
  const { [LAUNCHDARKLY_TOGGLES.SIMPLIFIED_CALENDAR]: simplifiedCalendar } = useFlags();

  return simplifiedCalendar ? getCalendarDefaultPath() : UrlPaths.SCHEDULE.ROOT;
};

export default useScheduleHomePath;
